import React, { Component } from "react";
import userServices from "../../Services/userService";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";

import Swal from "sweetalert2";

export default class TokenConf extends Component {
  componentDidMount() {
    var token = this.props.match.params.token;
    var confType = this.props.match.params.confType;
    var clientEmail = this.props.match.params.clientEmail;
    if (!token || !confType) {
      return;
    }

    // if its a user that tries to confirm his/her email
    if (confType === "confEmail") {
      userServices.tryConfEmailToken(token, clientEmail).then((res) => {
        if (res["success"]) {
          Swal.fire("אושר", "אימייל אושר בהצלחה", "success").then(() => {
            this.props.history.push("/login");
          });
        } else {
          Swal.fire("", "אישור מייל לא תקין", "warning");
        }
      });
    }
  }

  render() {
    return (
      <div className="container">
        <Card>
          <CardContent className="login-card">
            <h4 className="primary-color mb-40">אישור אימייל</h4>
          </CardContent>
        </Card>
      </div>
    );
  }
}
